import { Badge, Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Typography , getContrastRatio} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomCard from "../../../components/CustomCard";
import "@fontsource/rubik";
import { borderRadius, width } from "@mui/system";
import EventStageBar from "./EventStageBar";
import { useDispatch, useSelector } from "react-redux";
import { convertTimeSecondsToMinutes, downloadS3File, getInitials, getStatusNameFromStatusTypeOrder, timeStampToDayString } from "../../../utils/commonServices";
import CustomTooltip from "../../../components/CustomTooltip";
import { updateState } from "../../../redux/commonSlice";
import { updateCreationState } from "../../../redux/eventCreationSlice";
import usePermissions from "../../../hooks/usePermissions";
import { PERMISSION } from "../../../constants/constants";
// import { customTheme as theme } from "../../../theme/customTheme";
import useCustomTheme from "../../../theme/useCustomTheme";
import { getNamesFromIds } from "../../../commonactions/actions";
import CloudUploadRoundedIcon from '@mui/icons-material/CloudUploadRounded';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import FiberNewIcon from '@mui/icons-material/FiberNew';
import MarkUnreadChatAltRoundedIcon from '@mui/icons-material/MarkUnreadChatAltRounded';
import ThumbDownOffAltRoundedIcon from '@mui/icons-material/ThumbDownOffAltRounded';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';
import luciLogo from "../../../assets/luci_icon.svg";
import VisibilityIcon from '@mui/icons-material/Visibility';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import StayCurrentLandscapeIcon from '@mui/icons-material/StayCurrentLandscape';
import StayCurrentPortraitIcon from '@mui/icons-material/StayCurrentPortrait';
import MovieOutlinedIcon from '@mui/icons-material/MovieOutlined';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';


const EventCard = (props) => {
    const { event } = props;
    const commonReducer = useSelector((state) => state.root.commonReducer);
    const dropdownReducer = useSelector((state) => state.root.dropdownReducer);
    const reviewEventReducer = useSelector((state)=> state.reviewEventReducer)
    //const event = commonReducer.events?.find((event) => event.id == eventId)
    const dispatch = useDispatch()
    const [theme ] = useCustomTheme()
    var collaborators = event?.collaborators?.map((collaborator) => collaborator.name)
    collaborators?.unshift(event?.owner_name);
    const [anchorEl, setAnchorEl] = useState(null);
    const [hasPermission] = usePermissions()
    const open = Boolean(anchorEl);
    const colors =[theme.palette.primary.main, '#000000', '#6C00FF']
    // const [deleteProject, deleteEventStatus] = useDeleteProject(eventId, refetchList);
    // console.log({event, collaborators})
    const handleClick = (event) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (e) => {
        e.stopPropagation();
        setAnchorEl(null);
    };

    const downloadFinalVideo = (e)=> {
        e.stopPropagation();
        downloadS3File(event?.final_video_download_url)
    }

    const setPageData = ()=> {
        dispatch(updateCreationState({
            pageData: {
                name : event?.name,
                start_date: event?.start_date,
                end_date: event?.end_date,
                editor_start_date: event?.editor_start_date,
                video_orientation: event?.video_orientation, // landscape | portrait
                // song:'',
                description: event?.description,
               // quality_options: [1],
                event_type_id: dropdownReducer.event_type.find((type)=> type.value == event.event_type)?.id,
                video_length_id: dropdownReducer.video_length.find((length)=> length.value == event.video_length)?.id,
            }
        }))
    }




    return <CustomCard
        {...props}
        sx={{
            ...props.sx,
            // width: { xs: '100%', md: 'calc(50% - 10px)', lg: 'calc(33% - 10px)', xl: 'calc(33% - 0px)' },
            width:'100%',
            minWidth: 325,
            // height: '100%',
            //  maxHeight: {md: '12vh', lg: '23%', xl: '21.33%'},
            backgroundColor: ((commonReducer?.role_name === 'QC' || commonReducer?.role_name === 'Editor') && event.status_type_order < 3) ? '#F9F9F9' :'#FFFFFF',
            mb:{xl:1}
        }}
    >
        <CustomTooltip title={((commonReducer?.role_name === 'QC' || commonReducer?.role_name === 'Editor') &&  event.status_type_order < 3 )? "Editing not started yet" : null}  PopperProps={{
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [10, -130],
            },
          },
        ],
      }} > 
        <Box className="flex col j-between" sx={{height:{xs:'130px',sm:'135px',md:'140px',lg:'150px',xl:'210px'}, borderRadius:'10px'}}>
        {/* <Box sx={{height:'100%'}}> */}
         <Box>
            <Box
                sx={{
                width: '100%',
                padding: '1.3% 1.6% 2.6% 5.3%'

                }}
            >
            <Box className='flex row ' gap={1} mt={{xs:0.2,md:0.3,lg:0.5,xl:0.8}} sx={{ width: '100%', height: { xs: '9px', md: '11px', lg: '12px', xl: '16px' }, justifyContent: 'flex-end' ,  alignItems:'baseline', pr:1.5}} >
           
                    
     
              
{/*                 
                    { event?.flag?.new_editing_cycle  ? <CustomTooltip title="New Edit Cycle"  PopperProps={{
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: [-35, -4],
                                },
                              },
                            ],
                          }} ><FiberNewIcon sx={{color:'#008000',  fontSize:{xs:'12px',sm:'14px',md:'16px',lg:'18px',xl:'24px'}}} /></CustomTooltip>  : null
} */}

{ event?.flag?.chat  ? <CustomTooltip title="Revisions logged, not submitted"  PopperProps={{
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: [-35, -4],
                                },
                              },
                            ],
                          }} ><MarkUnreadChatAltRoundedIcon sx={{color:'#E4D00A',  fontSize:{xs:'12px',sm:'14px',md:'16px',lg:'18px',xl:'24px'}}} /></CustomTooltip>  : null
}

{/* { event?.flag?.internal_revision_rejected ? <CustomTooltip title="Internal Revision Rejected"  PopperProps={{
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: [-35, -4],
                                },
                              },
                            ],
                          }} ><ThumbDownOffAltRoundedIcon sx={{color:'#c6131b',  fontSize:{xs:'12px',sm:'14px',md:'16px',lg:'18px',xl:'24px'}}} /></CustomTooltip>  : null
} */}

{/* { event?.flag?.editing_cycle_completed ? <CustomTooltip title="Editing cycle completed"  PopperProps={{
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: [-35, -4],
                                },
                              },
                            ],
                          }} ><TaskAltRoundedIcon sx={{color:'#008000', fontSize:{xs:'12px',sm:'14px',md:'16px',lg:'18px',xl:'24px'}}} /></CustomTooltip>  : null
} */}

{ event?.flag?.internal_revision && !event?.flag?.internal_revision_rejected && !event?.flag?.can_upload ? <CustomTooltip title="Action required from PM"  PopperProps={{
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: [-35, -4],
                                },
                              },
                            ],
                          }} ><VisibilityIcon sx={{ fontSize:{xs:'12px',sm:'14px',md:'16px',lg:'18px',xl:'24px'}}} /></CustomTooltip>  : null
}

{ event?.status_type_order == 5 ? <CustomTooltip title="Project completed"  PopperProps={{
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: [-35, -4],
                                },
                              },
                            ],
                          }} ><CheckCircleIcon sx={{ fontSize:{xs:'12px',sm:'14px',md:'16px',lg:'18px',xl:'24px'}, color:'#00d744'}} /></CustomTooltip>  : null
}


{ event?.flag?.editing_cycle_completed && !event?.flag?.new_editing_cycle  ? <CustomTooltip title="Action required from client"  PopperProps={{
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: [-35, -4],
                                },
                              },
                            ],
                          }} > <FiberManualRecordIcon sx={{ fontSize:{xs:'12px',sm:'14px',md:'16px',lg:'18px',xl:'24px'}, color:'red'}}/></CustomTooltip>  : null
}



                        {( event?.flag?.can_upload  ? <CustomTooltip title="Action required from editor "  PopperProps={{
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: [-35, -4],
                                },
                              },
                            ],
                          }} >
                          {/* <CloudUploadRoundedIcon sx={{color:theme.palette.secondary.main, fontSize:{xs:'14px',sm:'16px',md:'18px',lg:'20px',xl:'26px'}}} /> */}
                                 <Box  sx={{  width:{xs:'4%', lg:'4.5%'} , display:'flex', alignItems:'center', justifyContent:'center' }} >        
                                                    <img src={luciLogo}  width='100%' />  
                                  </Box>
                          </CustomTooltip>  : null)}

                         
{/* { !!event?.editing_cycle_count  ? <CustomTooltip title="Revision cycle count"  PopperProps={{
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: [-35, -4],
                                },
                              },
                            ],
                          }} >{event?.editing_cycle_count}</CustomTooltip>  : null
} */}


{/* 
{ event?.video_orientation == 'landscape'   ? <CustomTooltip title="Landsacpe"  PopperProps={{
                            
                          }} > <StayCurrentLandscapeIcon sx={{ fontSize:{xs:'12px',sm:'14px',md:'16px',lg:'18px',xl:'24px'}, }}/></CustomTooltip>  :  <CustomTooltip title="Portrait"  PopperProps={{
                           
                          }} > <StayCurrentPortraitIcon sx={{ fontSize:{xs:'12px',sm:'14px',md:'16px',lg:'18px',xl:'24px'}, }}/></CustomTooltip> 
} */}

{ event?.editing_cycle_count   ? <CustomTooltip title="Editing cycle count"  PopperProps={{
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: [-35, -4],
                                },
                              },
                            ],
                          }} >

    <Badge badgeContent={event?.editing_cycle_count} color="secondary" showZero sx={{  '& .MuiBadge-badge': { padding: '0 4px',
  },}}>
      <MovieOutlinedIcon      sx={{ fontSize: {xs:'12px',sm:'14px',md:'16px',lg:'18px',xl:'24px'}}} />
    </Badge>
                          </CustomTooltip>  : null
}

                
                {
                     ((commonReducer?.role_name === 'QC' || commonReducer?.role_name === 'Editor') &&  event?.status_type_order < 3  ? <NotInterestedIcon sx={{color:theme.palette.error.main}} />  : null)
                }
            </Box>
            {/* <Typography sx={{ fontSize: { xs: 7, md: 8,lg:'10px', xl: 13 }, mt: {xs:0.3,md:0.5,lg:0.6,xl:0.8}, fontWeight: 900, minHeight: '13.5px', fontFamily: 'Rubik' , color:'black', }}>{(event?.event_type && event?.event_type?.name)}</Typography> */}
        
                {/* <Box sx={{display:'flex', alignItems:'center', gap: 1}}>
            <Typography sx={{ fontSize: { xs: 7, md: 8,lg:'10px', xl: 13 }, fontWeight: 500,  fontFamily: 'Rubik' , color:'black', }}>{event?.organisation_name && `${event?.organisation_name}` }
             </Typography>
           
             </Box> */}
            

            <CustomTooltip title={event?.name?.length > 30 && event?.name} 
              placement= "top"
              PopperProps={{
                modifiers: [
                  {
                    name: "offset",
                    options: {
                      offset: [0, -8],
                    },
                  },
                ],
              }}  >
                
                <Typography
             
                    sx={{
                        fontSize: { xs: '10px', sm:'11px', md: '12px',lg:'13.33px', xl: '20px' },
                        fontWeight: 600, fontFamily: 'Rubik',
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        width: "100%",
                        // mt:{xs:0.4,md:0.5,lg:0.6,xl:1},
                        // backgroundColor:'red',
                        // height:'20p/x',
                        minHeight:{xs:'14px',md:'18px',lg:'20px',xl:'28px'},
                       
                    }}
                >   {event?.name}</Typography>
                
            </CustomTooltip>

               <Box sx={{display:'flex', alignItems:'center', gap: 1}}>
            <Typography sx={{ fontSize: { xs: 7, md: 8,lg:'10px', xl: 13 }, fontWeight: 500,  fontFamily: 'Rubik' , color:'#999', }}>{event?.organisation_name && `${event?.organisation_name}` }
             </Typography>
           
             </Box>

                <Box sx={{display:'flex', alignItems:'start', gap: 1, pt: {xs:'4px',sm:'5px', md: '6px', lg: '6px', xl: '6px' }}}>
            <Typography sx={{ fontSize: { xs: 7, md: 8,lg:'10px', xl: 13 }, fontWeight: 500,  fontFamily: 'Rubik' , color:'black', }}>{event?.event_type && `${event?.event_type?.name}  (${convertTimeSecondsToMinutes(event?.video_length)})` } </Typography>
            { event?.video_orientation == 'landscape'   ? <CustomTooltip title="Landsacpe" > <StayCurrentLandscapeIcon sx={{ fontSize:{xs:'9px',sm:'10px',md:'12px',lg:'15px',xl:'20px'}, }}/></CustomTooltip>  :  <CustomTooltip title="Portrait"> <StayCurrentPortraitIcon sx={{ fontSize:{xs:'9px',sm:'10px',md:'12px',lg:'15px',xl:'20px'}, }}/></CustomTooltip> 
            }
             </Box>

            <Box width='100%' className='flex row j-start' sx={{ fontSize: 10, fontWeight: 300, fontFamily: 'Rubik', pb: {xs:'2px',sm:'3px', md: '3px', lg: '3px', xl: '13px', overflowX: 'hidden' }}} gap={{xs:0.5,  lg:0,xl: 1.6}}>

                <Typography sx={{ fontSize: { xs: 7.5, md: 8.5,lg:'11px', xl: 13.5 }, fontWeight: 500, fontFamily: 'Rubik', mr: 1.5 }}>Start Date
                    <Typography component='span' sx={{ fontSize: { xs: 7.5, md: 8.5,lg:'11px', xl: 13.5 }, fontFamily: 'Rubik', fontWeight: 900, ml: 0.5 }} >{timeStampToDayString(event?.start_date)} </Typography>
                </Typography>

                <Typography sx={{ fontSize: { xs: 7.5, md: 8.5,lg:'11px', xl: 13.5 }, fontWeight: 500, fontFamily: 'Rubik' }} >Edit Start Date
                    <Typography component='span' sx={{ fontSize: { xs: 7.5, md: 8.5,lg:'11px', xl: 13.5 }, fontFamily: 'Rubik', fontWeight: 900, ml: 0.5 }} >{timeStampToDayString(event?.editor_start_date)} </Typography>
                </Typography>
            </Box>

            {/* <Box className='flex j-between' mt={1} > */}
            {/* {
               collaborators?.length > 0  && collaborators?.map((member, index) => {
                    return member != null && <Box className="j-center a-center" 
                    sx={{ display: 'inline-flex', borderRadius: '5px', backgroundColor: index == 0 ? theme.palette.primary.main : '#6C00FF', height: {xs:'12px',sm:'13px',md:'15px',lg:'16.67px',xl:'25px'}, width:  {xs:'12px',sm:'13px',md:'15px',lg:'16.67px',xl:'25px'}, fontFamily: 'Rubik', fontSize: { xs: 6, md: 7,lg:'7.33px', xl: 11 }, fontWeight: 600, color: index == 0 ?  getContrastRatio(theme.palette.primary.main , '#ffffff') > 2.5 ? '#ffffff' : '#000000' : '#ffffff', p: 0.5, marginLeft: '4px', marginRight: '4px' , marginTop:0}} >
                      { getInitials(event.owner_name)}
                    </Box>
                })
            } */}
            <Box sx={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'start', gap:1}}>
            <PeopleOutlineIcon/>

            {/* <Box className="j-center a-center" 
                    sx={{ display: 'inline-flex', borderRadius: '4px', backgroundColor:  theme.palette.primary.main , height: {xs:'12px',sm:'13px',md:'15px',lg:'16.67px',xl:'25px'}, width:  {xs:'12px',sm:'13px',md:'15px',lg:'16.67px',xl:'25px'}, fontFamily: 'Rubik', fontSize: { xs: 6, md: 7,lg:'7.33px', xl: 11 }, fontWeight: 600, color: '#ffffff', p: 0.5, marginLeft: '4px', marginRight: '4px' , marginTop:0}} >
                      { getInitials(event?.owner_name)}
            </Box> */}

                {
               event?.editors?.length > 0  && event?.editors?.map((member, index) => {
                    return member != null && <Box className="j-center a-center" sx={{ display: 'inline-flex', borderRadius: '5px',  height: {xs:'12px',sm:'13px',md:'15px',lg:'16.67px',xl:'25px'}, width:  {xs:'12px',sm:'13px',md:'15px',lg:'16.67px',xl:'25px'}, fontFamily: 'Rubik', fontSize: { xs: 6, md: 7,lg:'7.33px', xl: 11 }, fontWeight: 600, p: 0.5, marginLeft: '4px', marginRight: '4px' , marginTop:0,  backgroundColor: colors[index], color: getContrastRatio(colors[index], '#ffffff') > 2.5 ? '#ffffff' : '#000000', backgroundColor: colors[index],}} >
                      { getInitials(member)}
                    </Box>
                })
            }
            </Box>
            {/* <Typography sx={{ fontSize: { xs: 8, md: 9,lg:10, xl: 14  }, fontFamily: 'Rubik', fontWeight: 600, mr: 0.5}}>{getStatusNameFromStatusTypeOrder(event?.status_type_order)}</Typography> */}
            {/* </Box> */}
            </Box>
            </Box>
            <Box>
                <EventStageBar statusCode={event?.status_type_order} />
            </Box>
            {/* </Box> */}
        </Box>

        <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
                "aria-labelledby": "basic-button",
            }}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
            }}
            transformOrigin={{
                //   vertical: "top",
                //   horizontal: 133,
                vertical: -8,
                horizontal: 12
            }}
        >

           {(hasPermission(PERMISSION.ORGANISATION.PROJECT.DELETE) || hasPermission(PERMISSION.TEAM.PROJECT.DELETE)) &&  <MenuItem
                style={{ height: 24 }}
                onClick={(e) => {
                    e.stopPropagation();
                    //setEventName(event?.name)
                    //deleteProject();
                    if(commonReducer.user_name != event.owner_name) {
                        dispatch(updateState({delete_decline_popup: true, is_collaborator: true, event_delete_name: event?.name, production_event_id: event.id }))
                       
                    } else if(event?.status_type_order > 2 && event?.status_type_order < 5 ) {
                        dispatch(updateState({delete_decline_popup: true, is_collaborator: false, event_delete_name: event?.name, production_event_id: event.id}))
                    } else {
                        dispatch(updateState({event_delete_popup: true, is_collaborator: false, event_delete_name: event?.name, production_event_id: event.id}))
                    }
                    handleClose(e);
                }}
            >
                <ListItemText><Typography sx={{ fontFamily: 'Rubik', fontSize: { xs: '8px', md: '10px', lg: '11px', xl: '13px', fontWeight: 600, color: '#000000' } }}>Delete Project</Typography></ListItemText>
            </MenuItem>}


           {(hasPermission(PERMISSION.ORGANISATION.PROJECT.DUPLICATE) || hasPermission(PERMISSION.TEAM.PROJECT.DUPLICATE)) &&  <MenuItem
                style={{ height: 24 }}
                onClick={(e) => {
                    e.stopPropagation();
                    dispatch(updateCreationState({
                pageData: {
                name : event?.name,
                start_date: '',
                end_date: '',
                editor_start_date: '',
                video_orientation: event?.video_orientation, // landscape | portrait
                // song:'',
                description: event?.description,
               // quality_options: [1],
                event_type_id: dropdownReducer.event_type.find((type)=> type.value == event.event_type)?.id,
                video_length_id: dropdownReducer.video_length.find((length)=> length.value == event.video_length)?.id,
                }
                }))
                    dispatch(updateCreationState({open_form: true, duplicate: true, event_id: event.id}))
                    //dispatch(updateCreationState({open_backdrop_project_creation: true, duplicate: true, event_id: event.id}))
                    handleClose(e);
                }}
            >
               
                 {/* <ListItemIcon><ContentCopyIcon style={{fontSize: 18, marginLeft: 8}}/></ListItemIcon> */}
                <ListItemText><Typography sx={{ fontFamily: 'Rubik', fontSize: { xs: '8px', md: '10px', lg: '11px', xl: '13px', fontWeight: 600, color: '#000000' }}}>Duplicate Project</Typography></ListItemText>
            </MenuItem>}

{hasPermission(PERMISSION.PROJECT.INFO.EDIT) && 
            <MenuItem
            
                style={{ height: 24 }}
                onClick={(e) => {
                    e.stopPropagation();
                    if(event?.status_type_order < 3){
                    setPageData()
                     dispatch(updateCreationState({open_form: true, edit: true, event_id: event.id}))
                   // dispatch(updateCreationState({open_backdrop_project_creation: true, edit: true, event_id: event.id}))
                    }else{
                       
                        dispatch(updateCreationState({edit_decline_popup:true}))
                    }
                    handleClose(e);
                }}
            >
               
                {/* <ListItemIcon><EditIcon style={{fontSize: 18, marginLeft: 8}}/></ListItemIcon> */}
                <ListItemText><Typography sx={{ fontFamily: 'Rubik', fontSize: { xs: '8px', md: '10px', lg: '11px', xl: '13px', fontWeight: 600, color: '#000000' } }}>Edit Project</Typography></ListItemText>
            </MenuItem>}
        </Menu>
        </CustomTooltip>
    </CustomCard>
};
export default EventCard;